var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSafety(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10_330)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.6767 7.3756L33.4997 0.0251465L11.3227 7.3756C9.65179 7.92951 8.19791 8.99583 7.16756 10.4231C6.13721 11.8503 5.58278 13.566 5.58301 15.3263V33.5C5.58301 54.5045 31.2663 66.1039 32.3663 66.5869L33.3545 67.0251L34.3818 66.6846C35.4873 66.3161 61.4163 57.4441 61.4163 33.5V15.3263C61.4166 13.566 60.8621 11.8503 59.8318 10.4231C58.8014 8.99583 57.3476 7.92951 55.6767 7.3756ZM34.7392 39.0527C34.2511 39.5439 33.6704 39.9334 33.0306 40.1984C32.3908 40.4634 31.7048 40.5987 31.0123 40.5964H30.9202C30.2136 40.5856 29.5165 40.4316 28.8711 40.1437C28.2258 39.8558 27.6455 39.44 27.1654 38.9214L20.7278 32.2214L24.7562 28.3634L31.0207 34.8959L45.4843 20.4322L49.4317 24.3796L34.7392 39.0527Z",
    fill: "#00A79D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10_330"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 67,
    height: 67,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSafety);
export default __webpack_public_path__ + "static/media/safety.6956419c62ffb99f617c318cfb554d89.svg";
export { ForwardRef as ReactComponent };